/**
 * Internal helpers shared by the records-API modules. Not re-exported from
 * the barrel — consumers should never import from here directly.
 */
import { supabase } from '@/lib/supabase/client'

export function parseTitle(v: unknown): string {
  if (typeof v === 'string') return v
  if (v && typeof v === 'object') return (v as Record<string, string>).fa ?? ''
  return ''
}

export async function writeAuditEntry(params: {
  projectId: string
  recordId: string
  actorId: string
  actorRole: string
  action: string
  targetType?: string
  targetId?: string
  afterValue?: Record<string, unknown>
}): Promise<string | null> {
  try {
    const { data } = await supabase.rpc('write_audit_entry', {
      p_project_id: params.projectId,
      p_record_id: params.recordId,
      p_submission_id: null,
      p_actor_user_id: params.actorId,
      p_actor_role: params.actorRole,
      p_is_super_user_action: false,
      p_event_type: params.action,
      p_target_type: params.targetType ?? 'record',
      p_target_id: params.targetId ?? params.recordId,
      p_before: null,
      p_after: params.afterValue ?? null,
      p_metadata: {},
      p_description: null,
      p_parent_audit_id: null,
    })
    return (data as string | null) ?? null
  } catch {
    return null
  }
}

// `sendNotifications()` used to live here. Deleted rather than repaired: the
// notifications table has no INSERT policy (service-side writes only), so this
// client-side producer never wrote a row — it targeted a stale column shape
// AND died on RLS, silently, inside a best-effort try/catch. Production moved
// server-side in migration 20260718120000_notification_system.sql: AFTER
// triggers on records/comments/project_memberships plus emissions inside
// execute_form_publish. Clients only READ notifications now
// (features/notifications/). Do not reintroduce a client-side producer.
